import {
  SelectIntegrationTypeDrawerHeader,
  SelectNewIntegrationTypeDrawerContent,
} from '@modules/integrationsV2/components/SelectNewIntegrationTypeDrawer';
import { IntegrationsActionType } from '@modules/integrationsV2/store/integrationsActionType';
import { useIntegrationsStore } from '@modules/integrationsV2/store/integrationsStore';
import { Box, Drawer } from '@mui/material';
import { IntegrationFormDataViewFragment } from 'generated/graphql';

export interface SelectNewIntegrationTypeDrawerProps {
  integrationFormData: IntegrationFormDataViewFragment[];
}

export const SelectNewIntegrationTypeDrawer = ({
  integrationFormData,
}: SelectNewIntegrationTypeDrawerProps) => {
  const selectedIntegrationToConnect = useIntegrationsStore(
    ({ view }) => view.selectedIntegrationToConnect,
  );
  const dispatch = useIntegrationsStore(({ dispatch }) => dispatch);

  const shouldOpenDrawer = Boolean(selectedIntegrationToConnect);

  const onCloseDrawer = () => {
    dispatch({
      type: IntegrationsActionType.SET_VIEW,
      payload: {
        selectedIntegrationToConnect: null,
      },
    });
  };

  return (
    <Drawer open={shouldOpenDrawer} anchor="right" onClose={onCloseDrawer}>
      <Box width="60vw">
        <SelectIntegrationTypeDrawerHeader />
        <SelectNewIntegrationTypeDrawerContent
          integrationFormData={integrationFormData}
        />
      </Box>
    </Drawer>
  );
};
